module.exports = __webpack_public_path__ + "a695476bc3cd9b4e902aef2f6a115031.png";